module.exports = __webpack_public_path__ + "static/media/information.858df294.png";